import { ProjectionCategoryEnum } from '@enums/projection-category.enum';
import { ProjectionSubCategoryEnum } from '@enums/projection-sub-category.enum';
import { ArithmeticHelper } from '@helpers/arithmetic.helper';
import { HttpHelper } from '@helpers/http.helper';
import { PcgEntry, PcgEntryJson } from '@models/pcg-entry';
import { ProjectionLineStakeholder, ProjectionLineStakeholderJson } from '@models/projection-line-stakeholder';

export type ProjectionLineType = 'other' | 'tns' | 'is';

export interface ProjectionLineJson {
  id?: number;
  type?: ProjectionLineType;
  projection_category?: ProjectionCategoryEnum;
  projection_line_category?: ProjectionSubCategoryEnum;
  pcg_entry?: Partial<PcgEntryJson>;
  accounting_amount?: number;
  adjustment_amount?: number;
  adjusted?: boolean;
  projection_amount?: number;
  stakeholder?: ProjectionLineStakeholderJson;
  is_social_charges_required_pcg_entry?: boolean;
  is_remuneration_pcg_entry?: boolean;
}

export class ProjectionLine {
  constructor(
    public id?: number,
    public type?: ProjectionLineType,
    public projectionCategory?: ProjectionCategoryEnum,
    public projectionLineCategory?: ProjectionSubCategoryEnum,
    public pcgEntry?: PcgEntry,
    public accountingAmount?: number,
    public adjustmentAmount?: number,
    public adjusted?: boolean,
    public projectionAmount?: number,
    public stakeholder?: ProjectionLineStakeholder,
    public isSocialChargesRequiredPcgEntry?: boolean,
    public isRemunerationPcgEntry?: boolean
  ) {}

  static fromJson(json: ProjectionLineJson): ProjectionLine {
    return new ProjectionLine(
      json.id,
      json.type,
      json.projection_category,
      json.projection_line_category,
      json.pcg_entry ? PcgEntry.fromJson(json.pcg_entry) : null,
      ArithmeticHelper.round(json.accounting_amount, 2),
      ArithmeticHelper.round(json.adjustment_amount, 2),
      json.adjusted,
      ArithmeticHelper.round(json.projection_amount, 2),
      json.stakeholder ? ProjectionLineStakeholder.fromJson(json.stakeholder) : null,
      json.is_social_charges_required_pcg_entry,
      json.is_remuneration_pcg_entry
    );
  }

  static toJson(model: ProjectionLine): ProjectionLineJson {
    return {
      id: model.id,
      type: model.type,
      accounting_amount: model.accountingAmount,
      adjustment_amount:
        model.type === 'other' || (model.type === 'tns' && !model.isSocialChargesRequiredPcgEntry)
          ? model.adjustmentAmount
          : null,
      adjusted: model.adjusted,
      projection_amount: model.projectionAmount,
      stakeholder: model.type === 'tns' && model.stakeholder ? HttpHelper.toJsonId(model.stakeholder) : undefined,
      is_social_charges_required_pcg_entry: model.type === 'tns' ? model.isSocialChargesRequiredPcgEntry : undefined,
      projection_category: model.projectionCategory,
      projection_line_category: model.projectionLineCategory,
      pcg_entry: model.pcgEntry ? HttpHelper.toJsonId(model.pcgEntry) : undefined
    };
  }
}
